import { render, staticRenderFns } from "./ResultInput.vue?vue&type=template&id=38f1f60a&scoped=true"
import script from "./ResultInput.vue?vue&type=script&lang=js"
export * from "./ResultInput.vue?vue&type=script&lang=js"
import style0 from "./ResultInput.vue?vue&type=style&index=0&id=38f1f60a&prod&lang=scss"
import style1 from "./ResultInput.vue?vue&type=style&index=1&id=38f1f60a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f1f60a",
  null
  
)

export default component.exports